import { render, staticRenderFns } from "./PriceSelect.vue?vue&type=template&id=cda08eae&scoped=true&"
import script from "./PriceSelect.vue?vue&type=script&lang=js&"
export * from "./PriceSelect.vue?vue&type=script&lang=js&"
import style0 from "./PriceSelect.vue?vue&type=style&index=0&id=cda08eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda08eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VIcon,VLayout,VList,VListItem,VListItemTitle})
